import React from "react";
import ProgramsContent from "../FunctionComponents/ProgramsFolder/ProgramsContent";

function Programs() {
  return (
    <>
      <ProgramsContent />
    </>
  );
}

export default Programs;
